import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import isEmpty from "lodash/isEmpty";
import classNames from "classnames";

import { PageWrapper, Loader, Alert } from "../../components";
import Actions, { thunks } from "../../redux/modules/products";
import Details from "./components/categoryModal";
import AddCategory from "./components/addCategoryModal";

import BootstrapSwitchButton from "bootstrap-switch-button-react";

class Categories extends React.Component {
  state = {
    categoryToEdit: {},
    showSubcategory: "",
    isSubCategory: false,
    addCategory: false,
    addSubCategory: false,
  };

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(thunks.getCategories());
  }

  componentWillUnmount() {
    this.props.reset();
  }

  viewCategory = (category, isSubCategory) => {
    this.setState({ categoryToEdit: category, isSubCategory });
  };

  onHideCategoryDetails = () => {
    this.setState({
      categoryToEdit: {},
      isSubCategory: false,
      addCategory: false,
    });
  };

  onCategoryStatusChange = (e, id, parentId) => {
    console.log("Produt data", id, parentId);
    const { dispatch } = this.props;
    if (parentId) {
      let items = this.props.subCategories;
      let item = items.find((o) => o.id === id);
      item.status = e ? 1 : 0;
      // this.setState({ list: items });
    } else {
      let items = this.props.categories;
      let item = items.find((o) => o.id === id);
      item.status = e ? 1 : 0;
      // this.setState({ list: items });
    }
    const body = {
      status: e ? 1 : 0,
    };
    dispatch(thunks.changeCategoryStatus(body, id));
  };

  onPopularStatusChange = (e, id, parentId) => {
    console.log("Produt data", id, parentId);
    const { dispatch } = this.props;
    if (parentId) {
      let items = this.props.subCategories;
      let item = items.find((o) => o.id === id);
      item.is_popular = e ? 1 : 0;
      // this.setState({ list: items });
    } else {
      let items = this.props.categories;
      let item = items.find((o) => o.id === id);
      item.is_popular = e ? 1 : 0;
      // this.setState({ list: items });
    }
    const body = {
      is_popular: e ? 1 : 0,
    };
    dispatch(thunks.changeCategoryStatus(body, id));
  };

  onSeqNumberChange = (e, id, parentId) => {
    const { dispatch } = this.props;
    if (parentId) {
      let items = this.props.subCategories;
      let item = items.find((o) => o.id === id);
      item.seq_no = e.target.value;
      // this.setState({ list: items });
    } else {
      let items = this.props.categories;
      let item = items.find((o) => o.id === id);
      item.seq_no = e.target.value;
    }
    const body = {
      seq_no: e.target.value,
    };
    dispatch(thunks.changeCategoryStatus(body, id, parentId));
  };

  onSubcategoryStatusChange = (e, id) => {
    console.log("Produt data", id);
    // const { dispatch } = this.props;
    // let items = this.props.list;
    // let item = items.find(o => o.id === id);
    // item.userState = e ? 1 : 2;
    // this.setState({ list: items });
    // const body = {
    //     userId: id,
    //     userState: e ? 1 : 2
    // }
    // dispatch(thunks.changeProductStatus(body));
  };

  uploadImage = (file, isSubCategory) => {
    const { categoryToEdit, showSubcategory } = this.state;
    const { dispatch } = this.props;
    dispatch(
      thunks.uploadCategoryImage({
        id: categoryToEdit.id,
        file,
        parentID: isSubCategory ? showSubcategory : "",
      })
    );
    this.onHideCategoryDetails();
  };

  showSubcategory = (category) => {
    const { dispatch, updateProperty } = this.props;
    const { showSubcategory } = this.state;
    console.log(showSubcategory);
    updateProperty("subCategories", []);
    this.setState(
      { showSubcategory: category.id == showSubcategory ? "" : category.id },
      () => {
        if (category.id != showSubcategory)
          dispatch(thunks.getCategories(category.id));
      }
    );
  };

  handleAddCategory = () => {
    this.setState({
      addCategory: true,
    });
  };

  handleAddSubCategory = () => {
    this.setState({
      addSubCategory: true,
    });
  };

  handleCategory = (data) => {
    const { dispatch } = this.props;
    dispatch(thunks.saveCategory(data));
    this.onHideCategoryDetails();
  };

  handleEditCategory = (data, id) => {
    console.log(data, id);
    const { dispatch } = this.props;
    dispatch(thunks.updateCategory(data, id, null));
    this.onHideCategoryDetails();
  };

  deleteCategory = (id) => {
    const { dispatch } = this.props;
    dispatch(thunks.deleteCategory({ id }));
  };

  editCategory = (category) => {
    console.log(category);
    this.setState({
      categoryToEdit: category,
      addCategory: true,
    });
  };
  render() {
    const { loading, error, updateProperty, categories, subCategories } =
      this.props;
    let sampleObj = {
      array: [],
    };
    for (var l = 1; l <= categories.length; l++) {
      sampleObj.array[l] = l;
    }
    let optionItems = sampleObj.array.map((item) => (
      <option key={item}>{item}</option>
    ));

    let sampleObj1 = {
      array: [],
    };
    for (var l = 1; l <= subCategories.length; l++) {
      sampleObj1.array[l] = l;
    }
    let optionSubItems = sampleObj1.array.map((item) => (
      <option key={item}>{item}</option>
    ));
    const {
      categoryToEdit,
      showSubcategory,
      isSubCategory,
      addCategory,
      addSubCategory,
    } = this.state;
    return (
      <PageWrapper title="Categories List">
        <Loader show={loading && !categories.length} />
        <Alert
          show={!!error}
          onHide={() => updateProperty("error", "")}
          title="Categories"
          message={error}
        />
        <div className="animated fadeIn">
          <div className="row mt-3">
            <div className="col-md-12">
              <div className="card">
                <div className="card-body">
                  <div className="category-container">
                    <div className="d-flex justify-content-end mb-3">
                      <button
                        className="btn btn-primary"
                        onClick={this.handleAddCategory}
                      >
                        <i className="fa fa-plus" /> Add
                      </button>
                    </div>

                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Category</th>
                          <th>Image</th>
                          <th>Status</th>
                          <th>Sequence Number</th>
                          <th>Popular Category</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {categories.length ? (
                          categories.map((category, i) => (
                            <React.Fragment key={category.id}>
                              <tr>
                                <td>{category.id}</td>
                                <td>{category.displayName}</td>
                                <td>
                                  {category.image ? (
                                    <img
                                      src={category.image}
                                      alt={category.displayName}
                                      width="80px"
                                      height="80px"
                                    />
                                  ) : (
                                    "-"
                                  )}
                                </td>
                                <td>
                                  <BootstrapSwitchButton
                                    checked={category.status == 1}
                                    onstyle="success"
                                    offstyle="danger"
                                    size="xs"
                                    onChange={(e) =>
                                      this.onCategoryStatusChange(
                                        e,
                                        category.id
                                      )
                                    }
                                  />
                                </td>
                                <td>
                                  <select
                                    className="form-control-sm col-3"
                                    onChange={(e) =>
                                      this.onSeqNumberChange(e, category.id)
                                    }
                                    value={category.seq_no}
                                  >
                                    {optionItems}
                                  </select>
                                </td>
                                <td>
                                  <BootstrapSwitchButton
                                    checked={category.is_popular == 1}
                                    onstyle="success"
                                    offstyle="danger"
                                    size="xs"
                                    onChange={(e) =>
                                      this.onPopularStatusChange(e, category.id)
                                    }
                                  />
                                </td>
                                <td>
                                  <button
                                    title="View Category"
                                    className="btn btn-xs btn-info mr-2"
                                    onClick={() => this.viewCategory(category)}
                                  >
                                    <i className="fa fa-eye" />
                                  </button>
                                  <button
                                    title="View Sub-Category"
                                    className="btn btn-xs btn-primary mr-2"
                                    onClick={() =>
                                      this.showSubcategory(category)
                                    }
                                  >
                                    <i className="fa fa-list" />
                                  </button>
                                  <button
                                    title="Delete"
                                    className="btn btn-xs btn-danger"
                                    onClick={() =>
                                      this.deleteCategory(category.id)
                                    }
                                  >
                                    <i className="fa fa-trash" />
                                  </button>
                                  <button
                                    title="Edit"
                                    className="btn btn-xs btn-warning ml-2"
                                    onClick={() => this.editCategory(category)}
                                  >
                                    <i className="fa fa-edit" />
                                  </button>
                                </td>
                              </tr>

                              {/* Subcategory Table */}
                              {showSubcategory === category.id && (
                                <>
                                  <tr>
                                    <td colSpan="7">
                                      <table className="table table-bordered">
                                        <thead>
                                          <tr>
                                            <th>#</th>
                                            <th>SubCategory</th>
                                            <th>Image</th>
                                            <th>Status</th>
                                            <th>Sequence Number</th>
                                            <th className="d-flex justify-content-between">
                                              Actions
                                              <button
                                                className="btn btn-primary"
                                                onClick={
                                                  this.handleAddSubCategory
                                                }
                                              >
                                                <i className="fa fa-plus" /> Add
                                              </button>
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {subCategories.length ? (
                                            subCategories.map((sub) => (
                                              <tr key={sub.id}>
                                                <td>{sub.id}</td>
                                                <td>{sub.displayName}</td>
                                                <td>
                                                  {sub.image ? (
                                                    <img
                                                      src={sub.image}
                                                      alt={sub.displayName}
                                                      width="80px"
                                                      height="80px"
                                                    />
                                                  ) : (
                                                    "-"
                                                  )}
                                                </td>
                                                <td>
                                                  <BootstrapSwitchButton
                                                    checked={sub.status == 1}
                                                    onstyle="success"
                                                    offstyle="danger"
                                                    size="xs"
                                                    onChange={(e) =>
                                                      this.onCategoryStatusChange(
                                                        e,
                                                        sub.id,
                                                        sub.parentId
                                                      )
                                                    }
                                                  />
                                                </td>
                                                <td>
                                                  <select
                                                    className="form-control-sm col-3"
                                                    onChange={(e) =>
                                                      this.onSeqNumberChange(
                                                        e,
                                                        sub.id,
                                                        sub.parentId
                                                      )
                                                    }
                                                    value={sub.seq_no}
                                                  >
                                                    {optionSubItems}
                                                  </select>
                                                </td>
                                                <td>
                                                  <button
                                                    title="View SubCategory"
                                                    className="btn btn-xs btn-info mr-2"
                                                    onClick={() =>
                                                      this.viewCategory(
                                                        sub,
                                                        true
                                                      )
                                                    }
                                                  >
                                                    <i className="fa fa-eye" />
                                                  </button>
                                                  <button
                                                    title="Delete"
                                                    className="btn btn-xs btn-danger"
                                                    onClick={() =>
                                                      this.deleteCategory(
                                                        sub.id
                                                      )
                                                    }
                                                  >
                                                    <i className="fa fa-trash" />
                                                  </button>
                                                  <button
                                                    title="Edit"
                                                    className="btn btn-xs btn-warning ml-2"
                                                    onClick={() =>
                                                      this.editCategory(
                                                        category
                                                      )
                                                    }
                                                  >
                                                    <i className="fa fa-edit" />
                                                  </button>
                                                </td>
                                              </tr>
                                            ))
                                          ) : (
                                            <tr>
                                              <td
                                                colSpan="6"
                                                className="text-center"
                                              >
                                                No SubCategories Found
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>
                                    </td>
                                  </tr>
                                </>
                              )}
                            </React.Fragment>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="7" className="text-center">
                              No Categories Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <Details
          show={!isEmpty(categoryToEdit)}
          data={categoryToEdit}
          onHide={this.onHideCategoryDetails}
          uploadImage={this.uploadImage}
          isSubCategory={isSubCategory}
        /> */}
        <AddCategory
          show={addCategory || addSubCategory}
          onHide={this.onHideCategoryDetails}
          onAddCategory={this.handleCategory}
          onEditCategory={this.handleEditCategory}
          addSubCategory={addSubCategory}
          showSubcategory={showSubcategory}
          isEdit={!!categoryToEdit?.id}
          categoryToEdit={categoryToEdit}
        />
      </PageWrapper>
    );
  }
}

const mapStateToProps = ({
  products: { loadingCategories: loading, error, categories, subCategories },
}) => ({
  loading,
  error,
  categories,
  subCategories,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  updateProperty: bindActionCreators(Actions, dispatch).updateProperty,
  reset: bindActionCreators(Actions, dispatch).reset,
});

export default connect(mapStateToProps, mapDispatchToProps)(Categories);
